import { initializeApp } from "firebase/app";
//import { getMessaging, getToken, onMessage } from "firebase/messaging";
import Toastify from 'toastify-js';
import "toastify-js/src/toastify.css";

const firebaseConfig = {
  apiKey: "AIzaSyAGib4cFp24W08rwMlumrpILmwGObK1bMs",
  authDomain: "redated-5161c.firebaseapp.com",
  projectId: "redated-5161c",
  storageBucket: "redated-5161c.firebasestorage.app",
  messagingSenderId: "70014407763",
  appId: "1:70014407763:web:7191507ae7ef2c14b0a2a6",
  measurementId: "G-Q3C98VGGHF"
};

const app = initializeApp(firebaseConfig);
//const messaging = getMessaging(app);

// onMessage(messaging, (payload) => {
//   console.log("Message received. ", payload);
//   Toastify({
//     text: `${payload.notification.body}`,
//     duration: 5000,
//         newWindow: true,
//         close: true,
//         gravity: "bottom", 
//         position: "right", 
//         stopOnFocus: true, 
        
//         style: {
//             background: "#ffffff",
//             color: "#000000",
//             borderRadius:'2rem',
//           },
//   }).showToast();
// });

// onMessage(messaging, (payload) => {
//   console.log("Message received. ", payload);
//   Toastify({
//     text: `${payload.notification.body}`,
//     duration: 5000,
//         newWindow: true,
//         close: true,
//         gravity: "bottom", 
//         position: "right", 
//         stopOnFocus: true, 
        
//         style: {
//             background: "#ffffff",
//             color: "#000000",
//             borderRadius:'2rem',
//           },
//   }).showToast();
// });

// export function requestPermission() {
//   console.log("Requesting permission...");
//   Notification.requestPermission().then((permission) => {
//     if (permission === "granted") {
//       console.log("Notification permission granted.");
//       getToken(messaging, {
//         vapidKey: "BEhptSD1p6l5_LpnB-6PerD9FovS0yTz5cy1Ng_GOZNDtKMtwq9R6psbg_TTnKIRHbJLWKRHkNeGuIzdvgSZVo8",
//       })
//         .then((currentToken) => {
//           if (currentToken) {
//             console.log("Current FCM token: ", currentToken);
//             console.log("Current FCM token: ", currentToken);
//             localStorage.setItem('fcmToken', currentToken)
//             // Do something with the FCM token
//           } else {
//             console.log("Could not get token");
//           }
//         })
//         .catch((err) => {
//           console.error("Error getting FCM token:", err);
//         });
//     } else {
//       console.log("Do not have permission for notifications.");
//     }
//   });
// }

//requestPermission();

// export const onMessageListener = () =>

// new Promise((resolve) => {

// onMessage(messaging, (payload) => {

// resolve(payload);

// });

// });
